import React from "react";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import "./AlternateView.css";
import Logo from "../../assets/solutrak-logo.png";
import GeneralOpData from "./GeneralOpData";
import PerformanceData from "./PerformanceData";
import MaintenanceInfo from "./MaintenanceInfo";
import BuildingInfo from "./BuildingInfo";
import FaultInfo from "./FaultInfo";
import { useState, useEffect } from "react";
import TrafficInfo from "./TrafficInfo";
import Devices from "./Devices";
import ImpersonationDropDown from "../../components/ImpersonationDropdown/ImpersonationDropdown";

function AlternateView() {
  const [expandedSection, setExpandedSection] = useState(null);
  const [buildingDevices, setBuildingDevices] = useState(null);
  const [buildings, setBuildings] = useState([]);

  const toggleSection = (sectionName) => {
    setExpandedSection(expandedSection === sectionName ? null : sectionName);
  };

  const [cookies] = useCookies();

  useEffect(() => {
    var header = new Headers();
    header.append("Valid-token", cookies.token);
    console.log(cookies);

    var requestOptions = {
      method: "get",
      headers: header,
    };

    let buildings = [];
    const fetchBuildings = () => {
      fetch(
        `https://services.solucore.com/solutrak/api/buildings/getBuildingInfos`,
        requestOptions
      )
        .then((response) => response.json())
        .then((json) => {
          console.log(json);
          json.Data.map((buildingInfo, idx) => (buildings[idx] = buildingInfo));
        })
        .catch((error) => console.log("API Error" + error));
    };

    fetchBuildings();
    setBuildings(buildings);
  }, [cookies.token]);

  const sections = [
    { id: "devices", icon: "📱", label: "Devices", color: "from-blue-600 to-blue-700" },
    { id: "general", icon: "📊", label: "General Operating Data", color: "from-purple-600 to-purple-700" },
    { id: "performance", icon: "⚡", label: "Performance Data", color: "from-cyan-600 to-cyan-700" },
    { id: "maintenance", icon: "🔧", label: "Maintenance Information", color: "from-orange-600 to-orange-700" },
    { id: "fault", icon: "⚠️", label: "Fault Information", color: "from-red-600 to-red-700" },
    { id: "traffic", icon: "🛗", label: "Traffic Information", color: "from-emerald-600 to-emerald-700" },
  ];

  return (
    <div className="av-wrapper">
      {/* Top Bar */}
      <div className="av-top-bar">
        <a href="/Home">
          <img src={Logo} alt="Solutrak logo" className="av-logo" />
        </a>
        <div className="av-top-right">
          {cookies.userType === 'Admin' ? <ImpersonationDropDown /> : null}
        </div>
      </div>

      {/* Main Content */}
      <div className="av-main-content">
        {/* Sidebar with Building Selection */}
        <div className="av-sidebar">
          <div className="av-building-card">
            <h3 className="av-sidebar-title">Building Selection</h3>
            <div className="av-building-selector">
              <BuildingInfo buildings={buildings} setBuildingDevices={setBuildingDevices} />
            </div>
          </div>
        </div>

        {/* Main Panel */}
        <div className="av-panel">
          {/* Header */}
          <div className="av-header">
            <div>
              <h1 className="av-page-title">Elevator Monitoring Dashboard</h1>
              <p className="av-page-subtitle">Manage and monitor all building systems</p>
            </div>
          </div>

          {/* Content Grid */}
          <div className="av-sections-grid">
            {sections.map((section) => (
              <div
                key={section.id}
                className={`av-section-card ${expandedSection === section.id ? 'av-section-expanded' : ''}`}
              >
                {/* Section Header */}
                <div
                  className={`av-section-header bg-gradient-to-r ${section.color}`}
                  onClick={() => toggleSection(section.id)}
                >
                  <div className="av-section-title-wrapper">
                    <span className="av-section-icon">{section.icon}</span>
                    <h2 className="av-section-title">{section.label}</h2>
                  </div>
                  <span className="av-section-toggle">
                    {expandedSection === section.id ? '−' : '+'}
                  </span>
                </div>

                {/* Section Content */}
                {expandedSection === section.id && (
                  <div className="av-section-content">
                    {section.id === "devices" && buildingDevices && (
                      <Devices buildingDevices={buildingDevices} />
                    )}
                    {section.id === "general" && buildingDevices && (
                      <div className="av-content-wrapper">
                        {buildingDevices.map((device) => (
                          <GeneralOpData key={device.deviceId} deviceId={device.deviceId} />
                        ))}
                      </div>
                    )}
                    {section.id === "performance" && buildingDevices && (
                      <PerformanceData deviceId={buildingDevices[0].deviceId} />
                    )}
                    {section.id === "maintenance" && buildingDevices && (
                      <MaintenanceInfo deviceId={buildingDevices[0].deviceId} />
                    )}
                    {section.id === "fault" && buildingDevices && (
                      <div className="av-content-wrapper">
                        {buildingDevices.map((device) => (
                          <div key={device.deviceId}>
                            <h4 className="av-fault-header">Error per floor</h4>
                            <FaultInfo deviceId={device.deviceId} />
                          </div>
                        ))}
                      </div>
                    )}
                    {section.id === "traffic" && buildingDevices && (
                      <TrafficInfo />
                    )}
                    {!buildingDevices && (
                      <div className="av-no-data">
                        <p>Please select a building to view this data</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlternateView;
